

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image_1', 'image_2', 'map_image', 'adress', 'name', 'mail', 'mirror', 'button_text', 'button_link', 'scroll_id'],
    },
  ],

  properties: {
    image_1: {
      title: 'Image 1',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    image_2: {
      title: 'Image 2',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    map_image: {
      title: 'Map Image',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    adress: {
      title: 'Adresse',
      type: 'string',
    },
    name: {
      title: 'Name',
      type: 'string',
    },
    mail: {
      title: 'E-Mail',
      type: 'string',
    },
    mirror: {
      title: 'Spiegeln',
      type: 'boolean',
    },
    button_text: {
      title: 'Button Text',
      type: 'string',
    },
    button_link: {
      title: 'Button Link',
      type: 'url',
    },
    scroll_id: {
      title: 'ID for Scrolling',
      type: 'string',
    },
  },
  required: [],
});
